// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backend: 'https://api-gw.ucrop.dev',
  language: 'en',
  google_maps_api: 'AIzaSyCrzZWsKiBzYcMI3PPuENCXBYa1Hfa1Cgo',
  google_maps_api_android: 'AIzaSyCJQl3fML2VigfChPRrooelDgrBrEK5VPM',
  google_maps_api_ios: 'AIzaSyBqFxfwaxKtwFoCfnnrBD2HaaM-_Xy08HU',
  google_maps_static_api: 'AIzaSyAeVz5BLk8oawep9Hmm6XE28O9enpJduYc',
  frontend: 'https://my.ucrop.dev/',
  timeStamp: '23/06/2026 00:08:32',
  stripeKeys: {
    NTC: 'pk_test_51MSFPSIckW40TMhSyJ54uVNJoLAbX94GU8VgZyHHXvXi6CV4jTP3FHvpGRaLY1Cm6dgnnGlZfmUoNCR8TMBxY1hi00Nu7kBTuu',
    '1': 'pk_test_51SUlwW12rWVsHzpCRklDPEl4xiDAmi68pvi6OtmoemKOI8oz8atEmZZgjxBPCFzYWAJLb6lbj2Sm3egMcPPYGSEs00BW3jRHiq',
    // 1 = Novagric
  },
  mapbox_token:
    'pk.eyJ1IjoibnV0cmljb250cm9sIiwiYSI6ImNtMG1namszaTAyc3Yya3NqbXJrcjdlZ3cifQ.Cb6gtZUPyi8PPqzQO5pQHg',
  showBillingPopup: true,
};
